<div class="gehc-etudiants-application m-u--app-body">
  <transition
    name="fade-fast"
    mode="out-in"
  >
    <router-view />
  </transition>
  <m-dialog
    :open="isDialogMessageImportantActive"
    :state="MDialogState.Error"
    :width="MDialogWidth.Large"
    :negativeLink="false"
  >
    <span v-html="messageImportantGlobal" />
  </m-dialog>
</div>